const __version__ ='skipton_v1.0.0'

module.exports = {
    __version__
}

